module.exports = __webpack_public_path__ + "img/logo-white.59c84ebb.svg";